import React, { useState, useEffect } from 'react';
import { Table, Input, message, Row, Col, Button } from 'antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';

import { Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { TableWrapper } from '../../../container/styled';
import { API_ENDPOINT } from '../../../config/config';

function ImportantDocuments() {
  const [documents, setDocuments] = useState([]);
  const [busy, setBusy] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');

  const fetchDocuments = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/important-docs/query', {
        page: currentPage,
        pageSize,
        search,
      });
      const { data, total, status, message: msg } = response.data;
      if (status) {
        setDocuments(data);
        setTotalRows(total);
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error('Failed to fetch documents');
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [currentPage, pageSize, search]);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: '10%',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '10%',
    },
    {
      title: 'File Type',
      dataIndex: 'file_type',
      key: 'file_type',
      width: '7%',
      render: (text) => text?.toUpperCase() || '-'
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 10,
      export: false,
      render: (_, record) => (
        <div className="flex gap-2">
          <Button
            icon={<EyeOutlined />}
            onClick={() => window.open(`${API_ENDPOINT}/${record.file_path}`, '_blank')}
          />
        </div>
      ),
    },
    // {
    //   title: 'Actions',
    //   key: 'actions',
    //   render: (_, record) => (
    //     <div className="flex gap-2">
    //       <button
    //         type="button"
    //         className="ant-btn ant-btn-default"
    //         onClick={() => window.open(record.file_path, '_blank')}
    //       >
    //         <EyeOutlined /> View
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Important Documents" routes={[]} />
      <Main>
        <Row gutter={[16, 16]} className="mb-4">
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Input
                className="w-1/4"
                placeholder="Search documents"
                prefix={<SearchOutlined />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                allowClear
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <TableWrapper>
              <Table
                rowKey="id"
                loading={busy}
                bordered
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={documents}
                columns={columns}
                scroll={{ x: 'max-content' }}
              />
            </TableWrapper>
          </Col>
        </Row>
      </Main>
    </>
  );
}

export default ImportantDocuments; 